import type { Point } from '@extapia/shared';

export interface Viewport {
  scrollX: number; // world offset shown at screen origin
  scrollY: number;
  zoom: number; // 1.0 = 100%
}

export const screenToWorld = (p: Point, v: Viewport): Point => ({
  x: p.x / v.zoom + v.scrollX,
  y: p.y / v.zoom + v.scrollY,
});

export const worldToScreen = (p: Point, v: Viewport): Point => ({
  x: (p.x - v.scrollX) * v.zoom,
  y: (p.y - v.scrollY) * v.zoom,
});

export const clampZoom = (z: number): number => Math.max(0.1, Math.min(30, z));
